export enum CreditStatusEnum {
	"Active" = 1,
	"InActive" = 2,
	"Deleted" = 3,
	"Expired" = 4,
	"Flagged" = 5,
	"Used" = 6,
	"Used_Emergency" = 7,
}
